module.exports = __webpack_public_path__ + "img/7类2级.4f6b434d.png";